import { render, staticRenderFns } from "./breastpiece_bind_edit.vue?vue&type=template&id=2c27c86c"
import script from "./breastpiece_bind_edit.vue?vue&type=script&lang=js"
export * from "./breastpiece_bind_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports